import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { FormikProps, FormikProvider } from 'formik';

import { Textarea } from '@/components/generic';
import { LiveStreamModalType } from '@/enums';
import { AssetItem } from '@/pages/Event/Asset/AssetItem';
import { WaitingScreen } from '@/pages/Event/LiveStream/WaitingScreen';
import { TestIds } from '@/shared/test-ids';
import { Asset, ThemeProp } from '@/types';

type LiveStreamModalContentProps = {
  openedModal: LiveStreamModalType | null;
  dataMapping: Record<number, Asset[]>;
  landingAssetUrl: string;
  formikDescription: FormikProps<{ description: string }>;
  handleImageClick: () => void;
  description: string;
  setSelectedAsset: Dispatch<SetStateAction<Asset | undefined>>;
  selectedAsset: Asset | undefined;
};

export const LiveStreamModalContent = ({
  openedModal,
  dataMapping,
  landingAssetUrl,
  formikDescription,
  handleImageClick,
  description,
  setSelectedAsset,
  selectedAsset
}: LiveStreamModalContentProps) => {
  const [t] = useTranslation('common');

  switch (openedModal) {
    case LiveStreamModalType.UPLOADED_CONTENT:
    case LiveStreamModalType.COVER_PHOTO:
      return (
        <div
          data-testid={TestIds.liveStream.modalAssetsGrid}
          className={`grid ${
            dataMapping[openedModal]?.length && dataMapping[openedModal]?.length <= 3
              ? 'grid-cols-2 md:grid-cols-3'
              : 'grid-cols-2 pr-5 md:grid-cols-5'
          } gap-3`}>
          {dataMapping[openedModal]?.map((asset) => (
            <div key={asset.id} data-testid={TestIds.liveStream.modalAssetItem}>
              <AssetItem
                asset={asset}
                assetType={asset.assetType}
                canBeDeleted={false}
                setSelectedAsset={
                  setSelectedAsset as Dispatch<SetStateAction<Asset | ThemeProp | null>>
                }
                selectedAsset={selectedAsset as Asset}
                selectedVideoUrl={''}
              />
            </div>
          ))}
        </div>
      );
    case LiveStreamModalType.DESCRIPTION:
      return (
        <FormikProvider value={formikDescription}>
          <form
            data-testid={TestIds.liveStream.modalDescriptionForm}
            onSubmit={formikDescription.handleSubmit}>
            <div
              data-testid={TestIds.liveStream.modalDescriptionTextareaContainer}
              className='mb-3 px-3'>
              <Textarea
                id='description'
                label={t('description')}
                className='h-20'
                errorMessage={formikDescription.errors.description as string}
                isInvalid={
                  (!!formikDescription.errors.description &&
                    formikDescription.touched.description) as boolean
                }
              />
            </div>
          </form>
        </FormikProvider>
      );
    case LiveStreamModalType.WAITING_SCREEN:
      return (
        <WaitingScreen
          landingAssetUrl={landingAssetUrl}
          handleImageClick={handleImageClick}
          description={description}
        />
      );
    default:
      return null;
  }
};
